module.exports = __webpack_public_path__ + "84dc7cf3204421575c43dfff17a35f1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/apple_2023_chart.png
// module id = 1634
// module chunks = 0